import {
  LOGIN_USER,
  LOGOUT_USER,
  PARENT_LOGIN_USER,
  MENU_ITEMS
} from "./auth.types";

export default {
  [LOGIN_USER]({
    commit
  }, payload) {
    commit(LOGIN_USER, payload);
  },

  [PARENT_LOGIN_USER]({
    commit
  }, payload) {
    commit(PARENT_LOGIN_USER, payload);
  },

  [MENU_ITEMS]({
    commit
  }, payload) {
    commit(MENU_ITEMS, payload);
  },

  [LOGOUT_USER]({
    commit
  }) {
    commit(LOGOUT_USER);
  }
};
